import { isPlainObject } from '@flowio/is';

export default function isInternalPaymentRequest(
  pr: io.flow.v0.models.PaymentRequest | io.flow.internal.v0.models.InternalPaymentRequest,
): pr is io.flow.internal.v0.models.InternalPaymentRequest {
  return isPlainObject((pr as io.flow.internal.v0.models.InternalPaymentRequest).payment_request);
}
